import React, {ButtonHTMLAttributes} from 'react';
import styled from 'styled-components';
import StyledIcon from 'components/acommon/StyledIcon';
import {device} from 'styled/device';

export const ButtonWithPriceStyled = styled.button`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 190px;
  font-size: 16px;
  font-weight: 500;
  height: 48px;
  padding: 0 30px;
  background: white;
  border: 2px solid #e6e8ec;
  color: #777e90;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  transition: all 0.07s ease-in-out;

  &:hover {
    background: #353945;
    border: 2px solid #e6e8ec;
    color: #fcfcfd;

    * {
      color: #fcfcfd !important;
    }
  }

  .buttonPrice {
    color: #32d7be;

    &:hover {
      color: #fcfcfd;
    }
  }

  .buttonLabel {
  }

  @media (max-width: ${device.mobileM}) {
    max-width: 280px;
    font-size: 20px;
    justify-content: center;
    gap: 12px;

    .buttonPrice {
      font-weight: 700;
    }
  }
`;

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: React.ReactNode | string;
  icon?: React.ReactNode;
  price?: string;
};

const defaultProps: ButtonProps = {
  label: '',
  type: undefined,
  icon: null,
  price: undefined,
};

function ButtonWithPrice({
  icon,
  label,
  price,
  disabled,
  className,
  type,
  ...props
}: ButtonProps) {
  return (
    <ButtonWithPriceStyled
      disabled={disabled}
      className={className}
      type={type}
      {...props}
    >
      <span>
        <span className="buttonPrice">{`${price}`}&nbsp;</span>
        <span className="buttonLabel">{label}</span>
      </span>
      <StyledIcon name={icon} size="24" />
    </ButtonWithPriceStyled>
  );
}

ButtonWithPrice.defaultProps = defaultProps;
export {ButtonWithPrice};
export default ButtonWithPrice;
